import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IdentificationStepsService } from '../../../services/identification-steps.service';

@Component({
    selector: 'payment-identification-password-recovery-choose-continue-method',
    templateUrl: './payment.identification.password-recovery.choose-continue-method.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentIdentificationPasswordRecoveryChooseContinueMethodComponent {
    @Input() continueMethod: number;
    @Output() chosenContinueMethod: EventEmitter<number> = new EventEmitter();

    constructor(
        protected identificationStepsService: IdentificationStepsService
    ) { }

    /**
     * Continue method change listener. Emit chosenContinueMethod event.
     **/
    public chooseContinueMethod() {
        this.chosenContinueMethod.emit(this.continueMethod);
    }
    /**
     * Reset informed email.
     **/
    public cancel() {
        this.identificationStepsService.resetEmail();
        this.identificationStepsService.resetUser();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/identification/password-recovery/choose-continue-method/payment.identification.password-recovery.choose-continue-method.component.ts